import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./casting-pets.component.yml'))

export default class CastingPetsComponent extends React.Component<StoreProps, never> {
  render () {
    const { store, data: { pets, market, offeredService, requiredPlace } } = this.props
    if (!market.preferences['ask_employees_pets_allergy?'] || offeredService?.offered_service_type !== 'offered_service' || !offeredService?.ask_for_pets) return null
    if (requiredPlace !== 'customers_place') return null

    return <div className="inputCheckbox">
      { (['cat', 'dog'] as const).map(pet => <React.Fragment key={ pet }>
        <input type="checkbox" id={ pet } checked={ pets.includes(pet) } onChange={ evt => store.set({ pets: evt.target.checked ? pets.concat(pet) : pets.filter(_ => _ !== pet) }) } />
        <label htmlFor={ pet }>{ i18nScoped.t(`${pet}_checkbox_label`) }</label>
        <p className="castingStep-desc paragraph--desc u-mtn">{ i18nScoped.t(`${pet}_checkbox_desc`) }</p>
      </React.Fragment>) }
    </div>
  }
}
